/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Force_Takeover_TitleInputs */



/**
* | output |
* | --- |
* | "Take Over Tournament?" |
*
* @param {Offline_Force_Takeover_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_force_takeover_title = /** @type {((inputs?: Offline_Force_Takeover_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Force_Takeover_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reprendre le tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Tomar control del torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assumir controle do torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prendere controllo del torneo?")
	return /** @type {LocalizedString} */ ("Take Over Tournament?")
});